<template>
  <div id="wiiMenu">
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" class="inner" key="english">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Wii
                <span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                >
                  Menu
                </span>
              </h1>
              <p>
                A fun project i did is the recreation of the wii menu. It's
                <a
                  href="https://github.com/Fraulk/Wii-Menu"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >open source</a
                >.<br /><br />
                <a
                  href="https://wii-menu.netlify.app/#/"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >Live Demo</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>

      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" class="inner" key="french">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Menu
                <span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                >
                  Wii
                </span>
              </h1>
              <p>
                Un projet amusant que j'ai fait est la recréation du menu wii.
                Il est
                <a
                  href="https://github.com/Fraulk/Wii-Menu"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >open source</a
                >.<br /><br />
                <a
                  href="https://wii-menu.netlify.app/#/"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >Live Demo</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "WhoAmI",
  props: {
    english: Boolean,
  },
};
</script>